import React, { useState } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
// import ListView from '../utils/ListView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Row, Container } from 'react-bootstrap';
import ProjectsAddCustAppForm from './ProjectsAddCustAppForm';
import ProjectsCustStepper from './ProjectsCustStepper.js';
// import ProjCreateForm from './ProjCreateForm'
// import ProjCreateForm2 from './ProjCreateForm2'
// import Enums from '../../enums';
import queryString from 'query-string';
import { useMappedState, useDispatch, } from 'redux-react-hook';

export default function ProjectsAddCustApp(props) {
    const E_TYPE = {
        ALL: 0,
        SINGLE: 1
    };
    let date = new Date();
    let tmpFromData = {
        "p_type": 0,
        "name": "",
        "start_at": Tools.dateToFormatStr(date),
        "end_at": Tools.dateToFormatStr(new Date().setDate(date.getDate() + 1)),
        "max_people": 0,
        "extra_point": 0,
        "point": 0,
        "pointExtra": 0,
        "cash_point": 0,
        "max_people": 10000,
        "source": "EZC",
        "is_top": 1,
        "is_recom": 0,
        "start_page": "要認真填寫唷",
        "end_page": "快去抽大獎吧！",
        "full_page": "",
        "description": "填答時間約3分鐘，請認真填答喔！",
        "test": {
            isAll: true,
            isGender: false,
            gender: "male",
            isAge: false,
            isAddr: false,
        },
        "tag": "",
        "empty_1": "",
        "icon": "",
        "images": [],
        "is_del": 0,
    };
    const tmpItems = useMappedState(state => state.tmpItems) || tmpFromData;
    const questionIndex = props.index;
    const data = tmpItems[questionIndex];
    const q_type = (data && data.cf) ? data.cf.q_type : null;
    const dispatch = useDispatch();
    const [isDisabled, setIsDisabled] = useState(false);
    const [formData, setFormData] = useState(tmpFromData);

    Tools.init();
    API.init(this);

    function onSubmit(data) {
        console.log(data);
        if (null == data) return;
        let p_typeParse = parseInt(data.p_type);
        if (isNaN(p_typeParse)) {
            alert("請選擇問卷類型");
            return;
        }

        let tmp = { ...data };

        delete tmp["empty_1"];
        //------ TODO: 處理發送對象 --------
        delete tmp["test"];

        if (tmp.interval && tmp.interval.length > 0) {
            tmp.interval = new Date(tmp.interval).getTime();
        }

        //interval type
        if (data.p_type == 2) {
            if (!data.interval_year) data.interval_year = 0;
            if (!data.interval_month) data.interval_month = 0;
            if (!data.interval_day) data.interval_day = 0;
        }

        tmp.start_at = new Date(tmp.start_at).getTime();
        tmp.end_at = new Date(tmp.end_at).getTime();

        console.log(tmp);
        API.AddProject({
            ty: 0
        }, tmp)
            .then(response => {
                console.log(response);
                try {
                    if (response && response.responseData) {
                        if (response.responseData.pid) {
                            let pidTmp = response.responseData.pid;
                            props.history.push('/proj/edit/' + pidTmp + '/2');
                        }
                        else if (response.responseData.msg) {
                            alert(response.responseData.msg);
                        }
                    }
                } catch (e) {
                    console.warn(e.stack);
                }
                // if (!data || !data.code || 22040 != data.code) {
                //     //error
                //     alert("請確認帳密");
                // } else {
                //     props.history.push(API.first_page);
                // }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error)); //head, body
    }

    function render() {
        // const { list, sort_type, fields } = state,
        //     totalEntries = list.length,
        //     onListViewClicked = onListViewClicked;
        return (
            <>
                <h3>新增專案</h3>
                <ProjectsCustStepper step={0} pid={null} history={props.history} />
                <Row>
                    <Col className="mx-auto">
                        <ProjectsAddCustAppForm
                            formData={formData}
                            onUpdate={onSubmit}
                            isDisabled={false}
                            isAddProj={true} />
                    </Col>
                </Row>
            </>
        );
    }

    return render();
}